import { render } from "./ModalFocusPoint.vue?vue&type=template&id=12889db6"
import script from "./ModalFocusPoint.vue?vue&type=script&lang=js"
export * from "./ModalFocusPoint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__